import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { getAllYears } from "../../pages/dashboard/utils/utils";
import {
  calculateGrossByCategory,
  calculateNetProfitByCategory,
  getCategories,
} from "./utils";

function Chart({
  title = "Sales vs Purchases Overview",
  allObjects,
  receipts,
  sales,
  months,
  month,
  year,
  category,
  quarter,
  half,
}) {
  const [categories, setCategories] = useState([]); // Initialize as empty array
  const [totalPurchases, setTotalPurchases] = useState([]);
  const [totalSales, setTotalSales] = useState([]);
  const [netProfit, setNetProfit] = useState([]);

  useEffect(() => {
    const chartCategories = getCategories(month, year, quarter, half, category);
    setCategories(chartCategories);
  }, [month, year, quarter, half, category]);

  useEffect(() => {
    setNetProfit(
      calculateNetProfitByCategory(
        receipts,
        sales,
        month,
        year,
        category,
        quarter,
        half,
      ),
    );
    setTotalPurchases(
      calculateGrossByCategory(receipts, month, year, category, quarter, half),
    );
    setTotalSales(
      calculateGrossByCategory(sales, month, year, category, quarter, half),
    );
  }, [receipts, sales, month, year, category, quarter, half]);

  // const options = {
  //   chart: {
  //     type: "column",
  //     style: {
  //       fontFamily: "Inter, sans-serif",
  //     },
  //   },

  //   title: {
  //     text: title,
  //     align: "left",
  //     style: {
  //       fontSize: "18px",
  //       fontWeight: "600",
  //     },
  //   },

  //   credits: { enabled: false },

  //   xAxis: {
  //     categories: categories,
  //     crosshair: true,
  //     lineColor: "#e5e7eb",
  //     tickColor: "#e5e7eb",
  //     labels: {
  //       style: { color: "#6b7280" },
  //     },
  //   },

  //   yAxis: {
  //     title: {
  //       text: "Total Sales",
  //       style: { fontWeight: "500" },
  //     },
  //     gridLineColor: "#f3f4f6",
  //     labels: {
  //       formatter: function () {
  //         return "₱" + Highcharts.numberFormat(this.value, 0);
  //       },
  //       style: { color: "#6b7280" },
  //     },
  //   },

  //   legend: {
  //     align: "right",
  //     verticalAlign: "top",
  //     itemStyle: { fontWeight: "500" },
  //   },

  //   tooltip: {
  //     shared: true,
  //     useHTML: true,
  //     backgroundColor: "#111827",
  //     borderRadius: 8,
  //     style: { color: "#ffffff" },
  //     formatter: function () {
  //       let s = `<b>${this.x}</b><br/>`;
  //       this.points.forEach((point) => {
  //         s += `
  //         <span style="color:${point.color}">●</span>
  //         ${point.series.name}:
  //         <b>₱${Highcharts.numberFormat(point.y, 2)}</b><br/>
  //       `;
  //       });
  //       return s;
  //     },
  //   },

  //   plotOptions: {
  //     column: {
  //       borderRadius: 6,
  //       pointPadding: 0.1,
  //       groupPadding: 0.15,
  //       borderWidth: 0,
  //       stacking: "normal",

  //       dataLabels: {
  //         enabled: true,
  //         inside: true,
  //         crop: true,
  //         overflow: "none",
  //         allowOverlap: false,

  //         formatter: function () {
  //           const { height, width } = this.point.shapeArgs || {};

  //           // Minimum space required for label
  //           const minHeight = 24;
  //           const minWidth = 40;

  //           if (!height || !width) return null;
  //           if (height < minHeight || width < minWidth) return null;

  //           return "₱" + Highcharts.numberFormat(this.y, 0);
  //         },

  //         style: {
  //           color: "#0000000",
  //           textOutline: "none",
  //           fontWeight: "600",
  //           fontSize: "11px",
  //         },
  //       },
  //     },
  //   },

  //   colors: ["#22c55e", "#ef4444", "#3b82f6"],

  //   series: [
  //     {
  //       name: "Total Sales",
  //       data: totalSales,
  //     },
  //     {
  //       name: "Total Purchases",
  //       data: totalPurchases,
  //     },
  //     {
  //       name: "Net Profit",
  //       data: netProfit,
  //     },
  //   ],
  // };

  const options = {
    chart: {
      type: "column",
      style: {
        fontFamily: "Inter, sans-serif",
      },
    },

    title: {
      text: title,
      align: "left",
      style: {
        fontSize: "18px",
        fontWeight: "600",
      },
    },

    credits: { enabled: false },

    xAxis: {
      categories: categories,
      crosshair: true,
      lineColor: "#e5e7eb",
      tickColor: "#e5e7eb",
      labels: {
        style: { color: "#6b7280" },
      },
    },

    legend: {
      align: "right",
      verticalAlign: "top",
      itemStyle: { fontWeight: "500" },
    },

    yAxis: {
      title: {
        text: "Total Sales",
      },
      labels: {
        formatter: function () {
          return "₱" + Highcharts.numberFormat(this.value, 0);
        },
      },
    },

    tooltip: {
      pointFormat:
        "<b>{point.percentage:.1f}%</b> of total<br/>Value: ₱ {point.y}",
    },

    plotOptions: {
      column: {
        borderRadius: 6,
        pointPadding: 0.1,
        groupPadding: 0.15,
        borderWidth: 0,
        stacking: "normal",

        dataLabels: {
          enabled: true,
          inside: true,
          crop: true,
          overflow: "none",
          allowOverlap: false,

          formatter: function () {
            const { height, width } = this.point.shapeArgs || {};

            // Minimum space required for label
            const minHeight = 24;
            const minWidth = 40;

            if (!height || !width) return null;
            if (height < minHeight || width < minWidth) return null;

            return "₱" + Highcharts.numberFormat(this.y, 0);
          },

          style: {
            color: "#0000000",
            textOutline: "none",
            fontWeight: "600",
            fontSize: "11px",
          },
        },
      },
    },

    // colors: ["#22c55e", "#ef4444", "#3b82f6"],
    colors: ["#ef4444", "#22c55e"],

    series: [
      // {
      //   name: "Total Sales",
      //   data: totalSales,
      // },
      {
        name: "Total Purchases",
        data: totalPurchases,
      },
      {
        name: "Net Profit",
        data: netProfit,
      },
    ],
  };

  return (
    <>
      <div className="d-flex flex-column gap-3">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </>
  );
}

export default Chart;
